// extracted by mini-css-extract-plugin
module.exports = {"customPopUp":"SCPopUp-module__customPopUp","popupContainer":"SCPopUp-module__popupContainer"};